(function () {
  if (window.RenogyAuth) return;

  var REFRESH_API_PATH = '/api/v1/account/pc/do_refresh';
  var COOKIE_TTL_DAYS = 370;
  var COOKIE_REMOVE_DOMAINS = ['.renogy.com', '.renogy.cn'];
  var isRefreshing = false;
  var refreshPromise = null;
  var pendingRequests = [];
  var expiredHandler = null;
  var authExpiredDispatched = false;

  // 读取主题注入到页面上的全局运行配置。
  function getConfig() {
    return window.renogyConfig || {};
  }

  // 获取当前站点 API 域名。
  function getApiDomain() {
    return getConfig().apiUrl || '';
  }

  // 获取当前运行环境，用来拼接 token cookie key。
  function getMode() {
    return getConfig().mode || 'prod';
  }

  // access token 对应的 cookie key。
  function getAccessTokenKey() {
    return 'renogy_account_access_token_key_' + getMode() + '_1.0';
  }

  // refresh token 对应的 cookie key。
  function getRefreshTokenKey() {
    return 'renogy_account_refresh_token_key_' + getMode() + '_1.0';
  }

  // 按名称读取单个 cookie。
  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + String(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  // 读取当前 access token。
  function getAccessToken() {
    return getCookie(getAccessTokenKey());
  }

  // 读取当前 refresh token。
  function getRefreshToken() {
    return getCookie(getRefreshTokenKey());
  }

  // 根据当前访问域推断认证 cookie 应写入的主域。
  function getCookieDomain() {
    var host = String(window.location.hostname || '').toLowerCase();
    if (!host) return '';
    if (host === 'renogy.cn' || /(^|\.)renogy\.cn$/.test(host)) return '.renogy.cn';
    if (host === 'renogy.com' || /(^|\.)renogy\.com$/.test(host)) return '.renogy.com';
    return '';
  }

  // 用原生方式设置 cookie，避免依赖第三方 cookie 库。
  function setCookie(name, value, options) {
    var settings = options || {};
    var parts = [encodeURIComponent(name) + '=' + encodeURIComponent(value)];

    if (settings.path) parts.push('path=' + settings.path);
    if (settings.domain) parts.push('domain=' + settings.domain);
    if (typeof settings.expires === 'number') {
      parts.push('expires=' + new Date(Date.now() + settings.expires * 864e5).toUTCString());
    } else if (settings.expires instanceof Date) {
      parts.push('expires=' + settings.expires.toUTCString());
    }
    if (settings.sameSite) parts.push('SameSite=' + settings.sameSite);
    if (settings.secure) parts.push('Secure');

    document.cookie = parts.join('; ');
  }

  // 把最新 access / refresh token 同步写回 cookie。
  function setAuthCookies(accessToken, refreshToken) {
    var cookieOptions = {
      path: '/',
      expires: COOKIE_TTL_DAYS,
      sameSite: 'Strict',
      secure: window.location.protocol === 'https:'
    };
    var domain = getCookieDomain();

    if (domain) {
      cookieOptions.domain = domain;
    }

    setCookie(getAccessTokenKey(), accessToken, cookieOptions);
    setCookie(getRefreshTokenKey(), refreshToken, cookieOptions);
  }

  // 删除指定域名下的单个 cookie。
  function removeCookie(name, domain) {
    var cookie = encodeURIComponent(name) + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    if (domain) cookie += '; domain=' + domain;
    if (window.location.protocol === 'https:') cookie += '; Secure';
    cookie += '; SameSite=Strict';
    document.cookie = cookie;
  }

  // 清理认证 cookie，兼容当前站点可能使用的不同主域。
  function clearAuthCookies() {
    var accessTokenKey = getAccessTokenKey();
    var refreshTokenKey = getRefreshTokenKey();
    var domains = COOKIE_REMOVE_DOMAINS.slice();
    var currentDomain = getCookieDomain();

    if (currentDomain && domains.indexOf(currentDomain) === -1) {
      domains.push(currentDomain);
    }

    removeCookie(accessTokenKey, '');
    removeCookie(refreshTokenKey, '');

    domains.forEach(function (domain) {
      removeCookie(accessTokenKey, domain);
      removeCookie(refreshTokenKey, domain);
    });
  }

  // 统一判断业务响应是否表示 token 已过期。
  function isTokenExpiredResponse(data) {
    if (!data || typeof data !== 'object') return false;

    var code = String(data.code || '').toUpperCase();
    var msg = String(data.msg || data.message || '').toUpperCase();

    return code === 'SEC003' || msg.indexOf('TOKEN_EXPIRED') > -1 || msg.indexOf('TOKEN EXPIRED') > -1;
  }

  // 把 Headers 实例或普通对象统一转换成可修改的 header map。
  function toHeadersMap(headers) {
    var result = {};
    if (!headers) return result;

    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      headers.forEach(function (value, key) {
        result[key] = value;
      });
      return result;
    }

    Object.keys(headers).forEach(function (key) {
      result[key] = headers[key];
    });
    return result;
  }

  // 统一创建“缺少 access token”错误，便于调用方在发送请求前拦截。
  function createMissingAccessTokenError() {
    var error = new Error('missing_access_token');
    error.code = 'AUTH_MISSING_TOKEN';
    return error;
  }

  // 规范化 fetch 参数，并在需要鉴权时自动补上 X-Token。
  function buildRequestOptions(options) {
    var source = options || {};
    var fetchOptions = {};

    Object.keys(source).forEach(function (key) {
      if (key === 'headers' || key === 'requireAuth') return;
      fetchOptions[key] = source[key];
    });

    fetchOptions.headers = toHeadersMap(source.headers);
    if (!fetchOptions.headers.Accept) {
      fetchOptions.headers.Accept = 'application/json';
    }

    if (source.requireAuth !== false) {
      var requestToken =
        fetchOptions.headers['X-Token'] || fetchOptions.headers['x-token'] || getAccessToken();
      if (requestToken) {
        fetchOptions.headers['X-Token'] = requestToken;
        delete fetchOptions.headers['x-token'];
      } else {
        delete fetchOptions.headers['X-Token'];
        delete fetchOptions.headers['x-token'];
      }
    }

    return fetchOptions;
  }

  // 支持相对路径和完整 URL 两种传参方式。
  function buildUrl(path) {
    var value = String(path || '');
    if (/^https?:\/\//i.test(value)) return value;
    return getApiDomain() + value;
  }

  // token 刷新成功后，依次恢复所有等待中的请求。
  function flushPendingRequests() {
    var queue = pendingRequests.slice();
    pendingRequests = [];
    queue.forEach(function (callback) {
      callback();
    });
  }

  // token 刷新失败时清空等待队列，防止请求永久挂起。
  function rejectPendingRequests(error) {
    pendingRequests = [];
    return error;
  }

  // 统一处理认证失效：清 cookie、发全局事件，并执行外部回调。
  function notifyAuthExpired(error) {
    clearAuthCookies();

    if (!authExpiredDispatched) {
      authExpiredDispatched = true;
      document.dispatchEvent(
        new CustomEvent('renogy:auth-expired', {
          detail: {
            error: error || null
          }
        })
      );
    }

    if (typeof expiredHandler === 'function') {
      try {
        expiredHandler(error || null);
      } catch (handlerError) {}
    }
  }

  // 单飞刷新 token；并发请求会共享同一个刷新 Promise。
  function refreshToken() {
    if (isRefreshing) {
      return refreshPromise;
    }

    var refreshTokenValue = getRefreshToken();
    if (!refreshTokenValue) {
      var missingRefreshTokenError = new Error('Refresh token not found');
      rejectPendingRequests(missingRefreshTokenError);
      notifyAuthExpired(missingRefreshTokenError);
      return Promise.reject(missingRefreshTokenError);
    }

    isRefreshing = true;
    authExpiredDispatched = false;

    var refreshHeaders = {
      'Content-Type': 'application/json'
    };
    var accessToken = getAccessToken();
    if (accessToken) {
      refreshHeaders['X-Token'] = accessToken;
    }

    refreshPromise = fetch(buildUrl(REFRESH_API_PATH), {
      method: 'POST',
      headers: refreshHeaders,
      body: JSON.stringify({
        refreshToken: refreshTokenValue
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Refresh failed');
        }
        return response.json();
      })
      .then(function (resp) {
        var data = resp && resp.data;
        if (!data || !data.accessToken || !data.refreshToken || resp.success === false || resp.fail) {
          throw new Error((resp && (resp.msg || resp.message)) || 'Refresh failed');
        }

        setAuthCookies(data.accessToken, data.refreshToken);
        flushPendingRequests();
        return resp;
      })
      .catch(function (error) {
        rejectPendingRequests(error);
        notifyAuthExpired(error);
        throw error;
      })
      .finally(function () {
        isRefreshing = false;
        refreshPromise = null;
      });

    return refreshPromise;
  }

  // 把待重试请求压入队列，等待刷新完成后重新执行。
  function enqueueRetry(retryFn) {
    return new Promise(function (resolve, reject) {
      pendingRequests.push(function () {
        retryFn().then(resolve).catch(reject);
      });

      refreshToken().catch(reject);
    });
  }

  // 统一请求入口：自动带 token，并处理 401 / SEC003 后的刷新重试。
  function request(path, options, hasRetried) {
    var retried = hasRetried === true;
    var sourceOptions = options || {};
    var sourceHeaders = toHeadersMap(sourceOptions.headers);
    var requestToken =
      sourceHeaders['X-Token'] || sourceHeaders['x-token'] || getAccessToken();

    if (sourceOptions.requireAuth !== false && !requestToken) {
      if (retried) {
        var missingAccessTokenError = createMissingAccessTokenError();
        notifyAuthExpired(missingAccessTokenError);
        return Promise.reject(missingAccessTokenError);
      }

      return enqueueRetry(function () {
        return request(path, options, true);
      });
    }

    var fetchOptions = buildRequestOptions(options);

    return fetch(buildUrl(path), fetchOptions).then(function (response) {
      if (response.status === 401) {
        if (retried || options && options.requireAuth === false) {
          var unauthorizedError = new Error('unauthorized');
          notifyAuthExpired(unauthorizedError);
          throw unauthorizedError;
        }

        return enqueueRetry(function () {
          return request(path, options, true);
        });
      }

      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error('HTTP Error ' + response.status + (text ? ': ' + text : ''));
        });
      }

      return response.json().then(function (data) {
        if (isTokenExpiredResponse(data)) {
          if (retried || options && options.requireAuth === false) {
            var tokenExpiredError = new Error((data && (data.msg || data.message)) || 'TOKEN_EXPIRED');
            notifyAuthExpired(tokenExpiredError);
            throw tokenExpiredError;
          }

          return enqueueRetry(function () {
            return request(path, options, true);
          });
        }

        return data;
      });
    });
  }

  // 注册外部认证失效回调，供页面做跳转或 UI 兜底。
  function setExpiredHandler(handler) {
    expiredHandler = typeof handler === 'function' ? handler : null;
  }

  window.RenogyAuth = {
    clearAuthCookies: clearAuthCookies,
    getAccessToken: getAccessToken,
    getApiDomain: getApiDomain,
    getRefreshToken: getRefreshToken,
    isTokenExpiredResponse: isTokenExpiredResponse,
    refreshToken: refreshToken,
    request: request,
    setExpiredHandler: setExpiredHandler
  };
})();
